import { SVGProps } from "react";

export function MapPointIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25 6.41699C5.25 6.88112 5.43437 7.32624 5.76256 7.65443C6.09075 7.98262 6.53587 8.16699 7 8.16699C7.46413 8.16699 7.90925 7.98262 8.23744 7.65443C8.56563 7.32624 8.75 6.88112 8.75 6.41699C8.75 5.95286 8.56563 5.50774 8.23744 5.17956C7.90925 4.85137 7.46413 4.66699 7 4.66699C6.53587 4.66699 6.09075 4.85137 5.76256 5.17956C5.43437 5.50774 5.25 5.95286 5.25 6.41699Z"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3006 9.71641L7.82549 12.1915C7.60673 12.41 7.31016 12.5328 7.00094 12.5328C6.69173 12.5328 6.39516 12.41 6.1764 12.1915L3.70074 9.71641C3.04812 9.06376 2.60368 8.23224 2.42364 7.327C2.24359 6.42176 2.33602 5.48346 2.68924 4.63076C3.04245 3.77805 3.64059 3.04923 4.40802 2.53646C5.17544 2.02369 6.07768 1.75 7.00065 1.75C7.92362 1.75 8.82586 2.02369 9.59329 2.53646C10.3607 3.04923 10.9589 3.77805 11.3121 4.63076C11.6653 5.48346 11.7577 6.42176 11.5777 7.327C11.3976 8.23224 10.9532 9.06376 10.3006 9.71641Z"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
